function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.847 8.45l.954 4.005-3.542-2.149L7 10.15l-.26.158-3.506 2.135.92-3.996.069-.294-.23-.197L.9 5.298l4.08-.326.305-.024.118-.282L6.987.856l1.592 3.81.117.282.304.024 4.1.328-3.091 2.656-.232.198.07.297z",
  stroke: "#EBCA62"
});

var SvgStarEmpty = function SvgStarEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _ref);
};

export default SvgStarEmpty;